<template>
  <ul class="am-list">
    <slot />
  </ul>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme/index.scss';
.am-list {
  width: 100%;
  background: $light-20;
  border-radius: 4px;
  border: solid 1px $light-40;
  padding: 1px;
}
</style>
